import { render, staticRenderFns } from "./CalendarEventModal.vue?vue&type=template&id=88de1064&scoped=true"
import script from "./CalendarEventModal.vue?vue&type=script&lang=ts"
export * from "./CalendarEventModal.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventModal.vue?vue&type=style&index=0&id=88de1064&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88de1064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88de1064')) {
      api.createRecord('88de1064', component.options)
    } else {
      api.reload('88de1064', component.options)
    }
    module.hot.accept("./CalendarEventModal.vue?vue&type=template&id=88de1064&scoped=true", function () {
      api.rerender('88de1064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/CalendarEventModal.vue"
export default component.exports